import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col } from "antd";
import { Switch } from "antd";
import { API_CREATE_SERVICE } from "api/service-managemnt";
import { useTranslation } from "react-i18next";
import { API_LIST_CATAGORY } from "api/catagory-managemnt";
import { API_CREATE_ITEM_SERVICE } from "api/item-services-managemnt";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { CONSTANTS } from "config/constant";
import { API_UPLOAD_IMAGE_ITEM_SERVICE } from "api/item-management";
import { API_CREATE_ITEM } from "api/item-management";
import { API_LIST_ITEM_SERVICE } from "api/item-services-managemnt";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { MdOutlineArrowBack } from "react-icons/md";

const CreateItem = () => {
  const Navigate = useNavigate();

  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionItemService, setSelectedOptionItemService] =
    useState(null);
  const [serviceData, setServiceData] = useState([]);
  const { t } = useTranslation();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [image, setImage] = useState();
  const [fileList, setFileList] = useState([]);

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      // Create a FormData object
      const formData = new FormData();
      formData.append("images", file);
      const response = await API_UPLOAD_IMAGE_ITEM_SERVICE(formData);

      console.log("result", response, file);
      // Handle success
      const newFileList = [
        {
          uid: response.id, // Replace with the unique ID you receive from the server
          name: response?.file?.[0]?.name,
          status: "done",
          url: CONSTANTS?.IMG_DIRECTORY + response?.file?.[0]?.file_url, // Replace with the URL of the uploaded image
        },
      ];

      console.log(newFileList);
      setFileList(newFileList);
      setImage(response?.file);
      onSuccess();
      toast.success(response?.message);

      console.log("result", response);
      console.log("newFileList", newFileList);
    } catch (error) {
      toast.error(error?.message);
      // Handle exceptions and errors
      console.log("error", error);
      onError(error);
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("Upload")}
      </div>
    </button>
  );
  const handleOptionChange = (event) => {
    const selectedIndex = event.target.value;
    setSelectedOption(data[selectedIndex]);
  };
  const handleOptionChangeItem = (selectedOptions) => {
    setSelectedOptionItemService(selectedOptions);
    console.log(selectedOptions); // This will log an array of selected options
  };
  // const handleOptionChangeItem = (event) => {
  //   const selectedIndex = event.target.value;
  //   setSelectedOptionItemService(serviceData[selectedIndex]);
  // };
  console.log("selectedOptionItemService", selectedOptionItemService);
  const fetchData = async () => {
    try {
      const params = {
        page: "",
        limit: "",
        name: "",
      };
      const newData = await API_LIST_CATAGORY(params);
      setData(newData?.categories);
      // setServiceData(newData?.categories);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchDatas = async () => {
    try {
      const params = {
        page: "",
        limit: "",
        name: "",
      };
      const newData = await API_LIST_ITEM_SERVICE(params);
      console.log("newData", newData);
      setServiceData(newData?.item_services);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const options = serviceData?.map((option, index) => ({
    value: option?._id,
    label: option?.name,
  }));
  useEffect(() => {
    fetchData();
    fetchDatas();
  }, []);

  console.log("");

  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              name: "",
              description: "",
              category: "",
              price: "",
              item_service: [],
              images: image,
            }}
            validationSchema={Yup.object({
              name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(50, "Maximum character should be 50"),
              description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              selectedOptionItemService: Yup.array().min(
                1,
                "At least one service must be selected"
              ),

              item_service: Yup.array().of(
                Yup.object().shape({
                  price: Yup.number()
                    .required("Price is required")
                    .positive("Price must be positive")
                    .typeError("Price must be a number"),
                })
              ),
              // price: Yup.string().required("Required"),

              // category: Yup.string().required("Required"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              try {
                const { category, images, ...data } = values;

                const payload = {
                  ...data,
                  category: selectedOption?._id,
                  images: image,
                  item_service: selectedOptionItemService?.map(
                    (option, index) => ({
                      item_service: option?.value,
                      price: values?.item_service[index]?.price || "",
                    })
                  ),
                  // item_service: [
                  //   {
                  //     item_service: selectedOptionItemService?._id,
                  //     price: values?.price,
                  //   },
                  // ],
                };

                let s = await API_CREATE_ITEM(payload);

                toast.success(s?.message);
                Navigate("/admin/items/item-tables");
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div
                  className="flex cursor-pointer items-center gap-2"
                  onClick={() => {
                    Navigate(-1);
                  }}
                >
                  <MdOutlineArrowBack
                    className="cursor-pointer"
                    style={{ fontSize: "17px" }}
                  />
                  <p>{t("Back")}</p>
                </div>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    {console.log("values", values)}
                    {/* Images */}
                    <div className="mb-3 flex justify-center">
                      <Upload
                        action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                        listType="picture-circle"
                        customRequest={customRequest}
                        fileList={fileList}
                        onPreview={handlePreview}
                        onChange={handleChange}
                      >
                        {fileList.length == 1 ? null : uploadButton}
                      </Upload>
                      {previewImage && (
                        <Image
                          wrapperStyle={{
                            display: "none",
                          }}
                          preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) =>
                              setPreviewOpen(visible),
                            afterOpenChange: (visible) =>
                              !visible && setPreviewImage(""),
                          }}
                          src={previewImage}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  {/* Existing fields */}
                  <Col span={12}>
                    {/* Service Name */}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="name"
                        placeholder={t("Name")}
                        maxLength={50}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    {/* Select Category */}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Select Category")}{" "}
                        <span className="text-[red]">*</span>
                      </label>
                      <select
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        onChange={handleOptionChange}
                        name="category"
                      >
                        <option value="">{t("Select an option")}</option>
                        {data?.map((option, index) => (
                          <option key={index} value={index}>
                            {option.title}
                          </option>
                        ))}
                      </select>
                      <ErrorMessage
                        name="category"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  {/* New fields */}
                  <Col span={12}>
                    {/* Select Category */}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Select Item Service")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <select
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onChange={handleOptionChangeItem}
                        name="category"
                      >
                        <option value="">Select an option</option>
                        {serviceData?.map((option, index) => (
                          <option key={index} value={index}>
                            {option.name}
                          </option>
                        ))}

                        

                      </select> */}
                      <Select
                        className="mt-2 flex h-11 w-full items-center  rounded-xl  border-2 border-gray-300 bg-white p-3  text-sm outline-none"
                        onChange={handleOptionChangeItem}
                        options={options}
                        // name="item_service"
                        isMulti
                        placeholder={t("Select options")}
                        value={selectedOptionItemService}
                      />
                      <ErrorMessage
                        name="selectedOptionItemService"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  {/* <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Item Service Price")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        type="text"
                        name="price"
                        placeholder={t("Item Service Price")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="price"
                        component="div"
                        className="text-red-500"
                      />
                    </div>{" "}
                  </Col> */}
                  <Col span={12}>
                    {/* Service Description */}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Description")}
                        {/* <span className="text-[red]">*</span> */}
                      </label>
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        as="textarea"
                        name="description"
                        placeholder={t("Description")}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12} className="relative bottom-[42px]">
                    {/* Dynamic Price Fields */}
                    <FieldArray name="item_service">
                      {({ remove, push }) => (
                        <>
                          {selectedOptionItemService?.length > 0 &&
                            selectedOptionItemService?.map((item, index) => (
                              <div className="mr-3 w-full">
                                <label className="font-semibold">
                                  {`Service ${item?.label} Price`}
                                  {/* <span className="text-[red]">*</span> */}
                                </label>
                                <Field
                                  className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  name={`item_service.${index}.price`}
                                  placeholder={`Service ${index + 1} Price`}
                                />
                                <ErrorMessage
                                  name={`item_service.${index}.price`}
                                  component="div"
                                  className="mt-1 text-sm text-red-500"
                                />
                              </div>
                            ))}
                        </>
                      )}
                    </FieldArray>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Creating") + "..." : t("Create Item")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateItem;
